import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { URLS } from 'app/services/api.service';
import { environment } from 'environments/environment';

@Injectable()
export class AndamentoService {

  constructor(    private apiService: ApiService,
    ) { }

  public getAndamentos (){
    this.apiService.get(URLS.ANDAMENTOS.GET_ANDAMENTOS_FILTROS+"/3", '', environment.urlLaravel)
    //this.apiService.get("http://127.0.0.1:8000/api/v1/andamentos/filtros/3", '', '')
    .subscribe(
      function (data) {
        console.log(data)
        return data;
      },
      function (error) {
        console.log(error);
      });

  }

}



// WEBPACK FOOTER //
// ./src/app/services/andamento.service.ts